import { render, staticRenderFns } from "./AA-ArchivesVolume.vue?vue&type=template&id=28a14c2d&scoped=true&"
import script from "./AA-ArchivesVolume.vue?vue&type=script&lang=js&"
export * from "./AA-ArchivesVolume.vue?vue&type=script&lang=js&"
import style0 from "./AA-ArchivesVolume.vue?vue&type=style&index=0&id=28a14c2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a14c2d",
  null
  
)

export default component.exports